import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { Box, Center, Row, Text } from '~/commonComponents';
import { Icon } from '~/commonComponents/Icon/Icon';
import { useAppSelector } from '~/hooks';
import { Colors } from '~/themes/colors';

export const PreApprovedChargeTimelineBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const job = useAppSelector((state: any) => state.job.job);

  if (!job) {
    return null;
  }

  const { offer_owner: offerOwner } = job;

  // Check if office is pre-approved (invoiced)
  const isPreApproved = offerOwner?.is_pre_approved;

  // Only show if IS pre-approved
  if (!isPreApproved) {
    return null;
  }

  return (
    <Box margin={'20px 0px'}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          all: 'unset',
          width: '100%',
          backgroundColor: Colors.success_30,
          border: `1px solid ${Colors.success_600}`,
          padding: '10px 12px',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          boxSizing: 'border-box',
        }}
      >
        {/* Top row: Icon + Title + Arrow */}
        <Row alignItems="center" justifyContent="space-between">
          <Row alignItems="center">
            <Icon name="solid-dollar" size={24} color={Colors.success_500} />
            <Text fontSize={18} bold color={Colors.success_500} marginLeft={4}>
              Book Now, Pay Later!
            </Text>
          </Row>
          <Center
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}
          >
            <Icon name="chevron-down" size={24} color={Colors.success_500} />
          </Center>
        </Row>
      </button>

      {/* Expanded content */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            style={{
              overflow: 'hidden',
              backgroundColor: Colors.success_30,
              border: `1px solid ${Colors.success_600}`,
              borderTopWidth: 0,
              padding: '0px 40px 12px 40px',
              marginTop: -1,
            }}
          >
            <Text color="success_500">
              Your office will be invoiced after the shift ends and time adjustments are settled.
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};
